import { API_URL } from './config/api';
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Route, Routes, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Header from './components/Header';
import MainNavigationMenu from './components/MainNavigationMenu';
import './App.css';
import './modern.css';
import PageSeo from './components/PageSeo';
export const UserContext = React.createContext(null);
const Page0 = lazy(() => import('./components/Home'));
const Page1 = lazy(() => import('./components/WallOfFame'));
const Page2 = lazy(() => import('./components/VideosPage'));
const Page3 = lazy(() => import('./components/Account'));
const Page4 = lazy(() => import('./components/posts/TopPost'));
const Page5 = lazy(() => import('./components/posts/Toptenposts'));
const Page6 = lazy(() => import('./components/TopComment'));
const Page7 = lazy(() => import('./components/posts/ForYou'));
const Page8 = lazy(() => import('./components/posts/Global'));
const Page9 = lazy(() => import('./components/posts/PostById'));
const Page10 = lazy(() => import('./components/admin/Allanoadminhappy'));
const Page11 = lazy(() => import('./components/admin/TotalViews'));
const Page12 = lazy(() => import('./components/monetisation/MemeBattles'));
const Page13 = lazy(() => import('./components/admin/EmailUsers'));
const Page14 = lazy(() => import('./components/monetisation/GiftBox'));
const Page15 = lazy(() => import('./components/PrivacyAndPlocies/Policies'));
class PageBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? <div className="feed-state" role="alert"><h2>Something went wrong.</h2><p>Please reload to try again.</p><button onClick={() => window.location.reload()}>Reload</button></div> : this.props.children;
  }
}
function App() {
  const [user, setUser] = useState(null);
  const { pathname } = useLocation();
  const isAnalytics = pathname.toLowerCase() === '/allanototalviews';
  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${API_URL}/auth/login/success`, { withCredentials: true, timeout: 8000, signal: controller.signal })
      .then(({ data }) => setUser(data.user?._json || null)).catch(() => {});
    return () => controller.abort();
  }, []);
  return <UserContext.Provider value={user}>
    <PageSeo />
    <a className="skip-link" href="#main-content">Skip to content</a>
    {!isAnalytics && <><Header /><MainNavigationMenu /></>}
    <main id="main-content" className={isAnalytics ? "app-main analytics-main" : "app-main"}><PageBoundary><Suspense fallback={<div className="feed-state" role="status">Loading your next laugh…</div>}><Routes>
      <Route path="/" element={<Page0 />} />
      <Route path="/wallOfFame" element={<Page1 />} />
      <Route path="/videosPage" element={<Page2 />} />
      <Route path="/account" element={<Page3 />} />
      <Route path="/toppost" element={<Page4 />} />
      <Route path="/toptenposts" element={<Page5 />} />
      <Route path="/topcomment" element={<Page6 />} />
      <Route path="/foryou" element={<Page7 />} />
      <Route path="/global" element={<Page8 />} />
      <Route path="/postbyid" element={<Page9 />} />
      <Route path="/meme/:token" element={<Page9 />} />
      <Route path="/allano" element={<Page10 />} />
      <Route path="/allanoTotalViews" element={<Page11 />} />
      <Route path="/memebattle" element={<Page12 />} />
      <Route path="/email" element={<Page13 />} />
      <Route path="/giftbox" element={<Page14 />} />
      <Route path="/policies" element={<Page15 />} />
      <Route path="*" element={<div className="feed-state"><h1>Page not found</h1><Link to="/">Back to your feed</Link></div>} />
    </Routes></Suspense></PageBoundary></main>
  </UserContext.Provider>;
}
export default App;
